import { Link } from "react-router-dom";

const stats = [
  { value: "500+", label: "影视条目" },
  { value: "1200+", label: "演员资料" },
  { value: "每日", label: "资讯更新" },
];

export default function IntroSection() {
  return (
    <section className="w-full px-4 md:px-8 mt-12 md:mt-16">
      <div className="rounded-lg bg-primary-500 text-background-50 px-6 md:px-12 py-10 md:py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl">
              关于「我的老婆姐姐」
            </h2>
            <p className="mt-4 text-sm md:text-base text-primary-50/90 leading-relaxed">
              我们是一个专注影视剧内容的信息平台，围绕最新影视资讯、剧情介绍与演员资料，
              为喜欢追剧的你提供一站式浏览体验。无论你是想快速了解一部新剧的看点，
              还是想系统梳理一位演员的代表作品，都能在这里找到清晰、易读的内容。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="px-5 py-2.5 rounded-md bg-accent-500 text-secondary-950 font-label font-semibold text-sm hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                了解我们
              </Link>
              <Link
                to="/search"
                className="px-5 py-2.5 rounded-md border border-background-50/40 text-background-50 font-label font-medium text-sm hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
              >
                开始选片
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-3 md:gap-5">
            {stats.map((s) => (
              <div
                key={s.label}
                className="rounded-lg bg-primary-600/60 border border-primary-400/30 px-3 py-5 text-center"
              >
                <p className="font-heading font-extrabold text-xl md:text-2xl text-accent-400">
                  {s.value}
                </p>
                <p className="mt-1 text-xs md:text-sm text-primary-50/80">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}